export class ViewTypes {
  static RAMP_VIEW_MEMO = 'RAMP_VIEW_MEMO';
  static RAMP_VIEW_PAIR_CHAT = 'RAMP_VIEW_PAIR_CHAT';
}
